// // // import React from "react";
// // // import AnalyticsNavigation from "../Analytics/AnalyticsNavigation";

// // // const TrainingAndPerformance = () => {
// // //   return (
// // //     <>
// // //       <AnalyticsNavigation />
// // //       <h3>Training Performance Charts Coming...</h3>
// // //     </>
// // //   );
// // // };

// // // export default TrainingAndPerformance;

// // // import React from "react";
// // // import { Box, Paper, Typography, Grid } from "@mui/material";
// // // import BarChart from "./Charts/BarChart";
// // // import LineChart from "./Charts/LineChart";
// // // import DonutChart from "./Charts/DonutChart";

// // // import {
// // //   latencyLabels,
// // //   latencyValues,
// // //   featureDonutLabels,
// // //   featureDonutValues,
// // //   dropOffLabels,
// // //   dropOffClient1,
// // //   dropOffClient2
// // // } from "../data/analyticsData";

// // // export default function TrainingAndPerformance() {
// // //   return (
// // //     <Box sx={{ p: 3 }}>

// // //       {/* ----- API Latency Chart ----- */}
// // //       <Paper sx={{ p: 3, mb: 3 }}>
// // //         <Typography fontWeight={600}>API Response Latency</Typography>
// // //         <Typography sx={{ mb: 2, fontSize: 14, color: "gray" }}>
// // //           Average latency per client store endpoint (ms)
// // //         </Typography>

// // //         <BarChart labels={latencyLabels} data={latencyValues} title="Latency (ms)" />
// // //       </Paper>

// // //       {/* ----- Feature Donut + Drop-off Chart Side by Side ----- */}
// // //       <Grid container spacing={3}>

// // //         {/* Donut Chart */}
// // //         <Grid item xs={12} md={6}>
// // //           <Paper sx={{ p: 3 }}>
// // //             <Typography fontWeight={600}>Feature Performance</Typography>
// // //             <Typography sx={{ fontSize: 14, color: "gray", mb: 3 }}>
// // //               Distribution of user intents
// // //             </Typography>
// // //             <DonutChart labels={featureDonutLabels} data={featureDonutValues} />
// // //           </Paper>
// // //         </Grid>

// // //         {/* Drop Off Line Chart */}
// // //         <Grid item xs={12} md={6}>
// // //           <Paper sx={{ p: 3 }}>
// // //             <Typography fontWeight={600}>Drop-Off per Feature</Typography>
// // //             <Typography sx={{ fontSize: 14, color: "gray", mb: 3 }}>
// // //               Avg. duration between sessions over time
// // //             </Typography>

// // //             <LineChart
// // //               labels={dropOffLabels}
// // //               data={dropOffClient1}
// // //               title="Alpha Retail - Flagship"
// // //             />

// // //             <LineChart
// // //               labels={dropOffLabels}
// // //               data={dropOffClient2}
// // //               title="Beta Corp - Online"
// // //             />

// // //           </Paper>
// // //         </Grid>
// // //       </Grid>
// // //     </Box>
// // //   );
// // // }

// // import React from "react";
// // import AnalyticsLayout from "../layout/AnalyticsLayout";
// // import ApiLatencyChart from "../charts/ApiLatencyChart";
// // import { Typography, Box } from "@mui/material";

// // export default function TrainingAndPerformance() {
// //   return (
// //     <AnalyticsLayout>
// //       {/* Page Title */}
// //       <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
// //         API Response Latency
// //       </Typography>

// //       {/* Chart Container */}
// //       <Box
// //         sx={{
// //           p: 3,
// //           borderRadius: "10px",
// //           border: "1px solid #E5E7EB",
// //           backgroundColor: "#fff",
// //           boxShadow: "0px 1px 3px rgba(0,0,0,0.06)",
// //         }}
// //       >
// //         <Typography sx={{ mb: 2, fontWeight: 500 }}>Latency by Client</Typography>
// //         <ApiLatencyChart />
// //       </Box>
// //     </AnalyticsLayout>
// //   );
// // }

// import React, { useEffect } from "react";
// import AnalyticsLayout from "./AnalyticsLayout";
// import BarChart from "./Charts/BarChart";
// import { Typography, Box } from "@mui/material";
// import { analyticsData } from "./Data/AnalyticsData";

// export default function TrainingAndPerformance() {
//   const labels = analyticsData.clients;
//   const latency = analyticsData.trainingPerformanceInsights.apiResponseLatency.map(i => i.avgLatencyMs);
//   useEffect(()=>{
//     console.log("latency",latency);
//   })

//   return (
//     <>
//       <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
//         API Response Latency
//       </Typography>

//       <Box sx={{ p: 3, border: "1px solid #E5E7EB", borderRadius: "10px", background: "#fff" }}>
//         <Typography sx={{ fontWeight: 500, mb: 2 }}>Latency by Client</Typography>
//         <BarChart   labels={labels} data={latency} title="Avg Latency (ms)" />
//       </Box>
//     </>
//   );
import React, { useEffect, useState } from "react";
import AnalyticsLayout from "./AnalyticsLayout";
import BarChart from "./Charts/BarChart";
import { Typography, Box, Button, CircularProgress } from "@mui/material";
import { Link as RouterLink, useNavigate, useOutletContext } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import config from "../../../config";

export default function TrainingAndPerformance() {
  const navigate = useNavigate();
  const { selectedDateRange } = useOutletContext();
  const [latencyData, setLatencyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchLatencyData();
  }, [selectedDateRange]);

  const fetchLatencyData = async () => {
    try {
      setLoading(true);
      const baseUrl = config.API_BASE_URL_V1;
      let url = `${baseUrl}/analytics/training-performance/api-latency`;

      // Add date filters if available
      if (selectedDateRange?.start_date && selectedDateRange?.end_date) {
        url += `?start_date=${selectedDateRange.start_date}&end_date=${selectedDateRange.end_date}`;
      }

      const response = await fetch(url, { headers: config.getHeaders() });
      const result = await response.json();
      setLatencyData(result.data || []);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error("Error fetching latency data:", err);
    } finally {
      setLoading(false);
    }
  };

  const labels = latencyData.map(item => item.organization_name);
  const latency = latencyData.map(item => item.avg_latency_ms);

  return (
    <>
      {/* Page title */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            width: "fit-content",
            whiteSpace: "nowrap",
          }}
        >
          API Response Latency
        </Typography>
      </Box>

      {/* Card wrapper */}
      <Box
        sx={{
          p: 3,
          border: "1px solid #E5E7EB",
          borderRadius: "10px",
          background: "#fff",
        }}
      >
        {/* Header row */}
        <Box
          sx={{
            mb: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography sx={{ fontWeight: 500 }}>Latency by Client</Typography>

          {/* View Details button — Solid Purple Always */}
          <Button
            onClick={() => navigate("/analytics/training-performance/details", { state: { selectedDateRange } })}
            size="small"
            sx={{
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.85rem",
              padding: "6px 12px",
              borderRadius: "8px",
              minWidth: "auto",
              backgroundColor: "#6A5BFF",
              color: "#fff",
              border: "1.5px solid #6A5BFF",
              transition: "background-color 0.2s ease",
              "&:hover": {
                backgroundColor: "#5A4DE0",
                borderColor: "#5A4DE0",
                color: "#fff",
              },
            }}
            endIcon={<ArrowForwardIosIcon sx={{ fontSize: 14 }} />}
          >
            View Details
          </Button>
        </Box>

        {/* Loading state */}
        {loading && (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        )}

        {/* Error state */}
        {error && !loading && (
          <Typography sx={{ color: "red", py: 2 }}>
            Error loading latency data: {error}
          </Typography>
        )}

        {/* Chart */}
        {!loading && !error && (
          <BarChart labels={labels} data={latency} title="Avg Latency (ms)" />
        )}
      </Box>
    </>
  );
}
